import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';

import { ButtonModule, DIALOG_DATA, DialogRef, IconModule, TextAreaComponentModule } from '@hglobal/fin-ui';
import { FormBuilder, FormGroup } from '@ngneat/reactive-forms';
import { GroupResolverFormBuilder } from '@ngneat/reactive-forms/lib/form-builder';
import { TranslateModule } from '@ngx-translate/core';

import { Transaction, Wallet } from '@kr/models';

export interface TransactionCommentForm {
  transactionId: number;
  comment: string;
  internalOrgId: number;
}

@Component({
  imports: [TranslateModule, IconModule, ButtonModule, ReactiveFormsModule, TextAreaComponentModule],
  selector: 'kr-comment-dialog',
  templateUrl: './comment-dialog.component.html',
  styleUrls: ['./comment-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentDialogComponent implements OnInit {
  readonly #fb = inject(FormBuilder);
  readonly #dialogRef = inject(DialogRef);
  readonly data = inject<{ transaction: Transaction; wallet: Wallet }>(DIALOG_DATA);

  transaction = this.data.transaction;
  wallet = this.data.wallet;
  isEdit = !!this.transaction.comment;

  form: FormGroup<GroupResolverFormBuilder<TransactionCommentForm>>;

  ngOnInit(): void {
    this.form = this.#fb.group({
      transactionId: this.transaction.id,
      internalOrgId: this.transaction.internalOrgId,
      comment: [this.transaction.comment, Validators.required],
    });
  }

  save(): void {
    this.#dialogRef.close({
      ...this.form.value,
    });
  }

  remove(): void {
    this.#dialogRef.close({
      ...this.form.value,
      comment: '',
    });
  }

  close(): void {
    this.#dialogRef.close();
  }
}
